<template>
  <div id="DaOptional">
    <div ref="getDisciplineInfo" style="height:500px;"></div>

    <div ref="getCombinationInfo" style="height:400px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        apiPath: '/api/ElectiveDiscipline/',
        chartGetDisciplineInfo: null,
        chartGetCombinationInfo: null,
    };
  },
  components: {},
  created: function() {
    
  },
  mounted: function() {
    
    this.GetDisciplineInfo();
    this.GetCombinationInfo();

    window.onresize = function () {
        this.chartGetDisciplineInfo.resize();
        this.chartGetCombinationInfo.resize();
    };

  },
  methods: {

        //学科统计--雷达图
        async GetDisciplineInfo () {
          
          this.chartGetDisciplineInfo = this.echarts.init(this.$refs.getDisciplineInfo);

          let option = {
              title: {
                  text: '选择学科统计'
              },
              tooltip: {},
              legend: {
                  top: 30,
                  //bottom: 20,
                  //show:false,
                  //data: ['预算分配（Allocated Budget）', '实际开销（Actual Spending）']
              },
              radar: {
                  // radius: '70%',
                  // shape: 'circle',
                  name: {
                      textStyle: {
                          color: '#fff',
                          backgroundColor: '#999',
                          borderRadius: 3,
                          padding: [3, 5]
                      }
                  },
                  indicator: [
                      // { name: '示例' },
                      //{ name: '管理（Administration）' },
                      //{ name: '信息技术（Information Techology）' },
                      //{ name: '客服（Customer Support）' },
                      //{ name: '研发（Development）' },
                      //{ name: '市场（Marketing）' }
                  ]
              },
              series: [{
                  name: '',
                  type: 'radar',
                  data: [
                      //{
                      //    value: [0],//[4300, 10000, 28000, 35000, 50000, 19000],
                      //    name: '2017级高中'
                      //},
                  ]
              }]
          };

          this.chartGetDisciplineInfo.setOption(option);
          this.chartGetDisciplineInfo.showLoading();
          let res = await this.xyapi.get(
            this.$store.state.apiPath + this.apiPath + 'GetDisciplineInfo'
          );
          if (res.success) {

              if (res.data.length > 0) {
                  let maxVal = 0;
                  let radarIndicatorArr = [];
                  let sgArr = [];//用于循环
                  let seriesDataList = [];
                  let disciplineArr = [];
                res.data.forEach( (item)=> {
                  //如果没有此年级,添加
                  if (sgArr.indexOf(item.StudentGradeName) < 0) {
                      sgArr.push(item.StudentGradeName);
                  }
                  //添加学科
                  if (disciplineArr.indexOf(item.DisciplineName) < 0) {
                      disciplineArr.push(item.DisciplineName);
                      //radarIndicatorArr.push({ name: item.DisciplineName });
                  }
                });
                sgArr.forEach( (sgItem)=> {
                  //每个年级各个学科学生数量
                  let disValue = [];
                  disciplineArr.forEach( (disItem)=> {
                    res.data.forEach( (item)=> {
                      if (item.DisciplineName === disItem && item.StudentGradeName === sgItem) {
                          if (maxVal <= item.Count) {
                              maxVal = item.Count;
                          }
                          disValue.push(item.Count);
                      }
                    });           
                  });
                  seriesDataList.push({
                      value: disValue,
                      name: sgItem
                  });
                });
                disciplineArr.forEach( (item)=> {
                  radarIndicatorArr.push({ name: item, max: maxVal });
                });

                option.radar.indicator = radarIndicatorArr;
                option.series[0].data = seriesDataList;

                this.chartGetDisciplineInfo.hideLoading();
                this.chartGetDisciplineInfo.setOption(option, true);

              }else{
                option = {};
                this.chartGetDisciplineInfo.hideLoading();
              }



          } else {
            this.xy.msgError(res.msg);
              // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
          }


      },

      //组合统计--折线图
      async GetCombinationInfo () {
          

          this.chartGetCombinationInfo = this.echarts.init(this.$refs.getCombinationInfo);
          let option = {
              title: {
                  text: '选择组合统计'
              },
              tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'cross',
                      label: {
                          backgroundColor: '#6a7985'
                      }
                  }
              },
              legend: {
                  show: false,
                  //data: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎']
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: [],//['周一', '周二', '周三', '周四', '周五', '周六', '周日']
              },
              yAxis: {
                  minInterval: 1,
                  type: 'value'
              },
              series: [
                  //{
                  //    name: '邮件营销',
                  //    type: 'line',
                  //    stack: '总量',
                  //    data: [120, 132, 101, 134, 90, 230, 210]
                  //},
                  //{
                  //    name: '联盟广告',
                  //    type: 'line',
                  //    stack: '总量',
                  //    data: [220, 182, 191, 234, 290, 330, 310]
                  //},
              ]
          };


          // 使用刚指定的配置项和数据显示图表。
          this.chartGetCombinationInfo.setOption(option);
          this.chartGetCombinationInfo.showLoading();

          let res = await this.xyapi.get(
            this.$store.state.apiPath + this.apiPath + 'GetCombinationInfo'
          );
          if (res.success) {

              let combinationArr = [];
              let studentGradeArr = [];

              let seriesDataList = [];
              res.data.forEach( (item)=> {
                //组合
                if (combinationArr.indexOf(item.CombinationName) < 0) {
                    combinationArr.push(item.CombinationName);
                }
                //年级
                if (studentGradeArr.indexOf(item.StudentGradeName) < 0) {
                    studentGradeArr.push(item.StudentGradeName);
                }
              });

                studentGradeArr.forEach( (sgItem)=> {
                  //每个年级各个学科学生数量
                  let sgDataArr = [];
                  combinationArr.forEach( (cbItem)=> {
                    res.data.forEach( (item)=> {
                      if (item.CombinationName === cbItem && item.StudentGradeName === sgItem) {
                          sgDataArr.push(item.Count);
                      }
                    });           
                  });
                  seriesDataList.push({
                      name: sgItem,
                      type: 'line',
                      stack: sgItem,//'总量',
                      data: sgDataArr
                  });
                });

              option.xAxis.data = combinationArr;
              option.series = seriesDataList;

              this.chartGetCombinationInfo.hideLoading();
              this.chartGetCombinationInfo.setOption(option, true);

          } else {
            this.xy.msgError(res.msg);
              // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
          }


      },

  }
};
</script>
<style lang='less' >
// #DaStudent {
  
// }
</style>

